export default "__VITE_ASSET__Crzxc8Op__"